// actions
import { PROJECT_SLICE_NAME } from '../actions/project.action';

// models
import type { ProjectState } from '../models/project.model';

// thunks
import { getProjectInfo, updateProject } from '../thunks/project.thunk';

// libraries
import { createSlice } from '@reduxjs/toolkit';

// initialState
const initialState: ProjectState = {
  projectInfo: undefined
};

// createSlice
const projectSlice = createSlice({
  name: PROJECT_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProjectInfo.fulfilled, (state, action) => {
        const { resultObject } = action.payload;

        state.projectInfo = resultObject;
      })
      .addCase(updateProject.fulfilled, (state, action) => {
        const { resultObject } = action.payload;

        state.projectInfo = resultObject;
      });
  }
});

export const project = projectSlice.name;
export const projectReducer = projectSlice.reducer;
export const projectActions = projectSlice.actions;
export default projectSlice.reducer;
